import { IsNotEmpty, IsUUID } from 'class-validator';

import { FormAttributesRequest } from '../../types';

import { UploadDocumentBatchElement } from './upload-document-batch-element';

const notEmptyOptions = {
  message: 'Обязательное поле',
};

export class UploadDocumentBatchDto {
  @IsUUID()
  @IsNotEmpty(notEmptyOptions)
  eventId: string;

  @IsUUID()
  @IsNotEmpty(notEmptyOptions)
  nodeId: string;

  @IsNotEmpty(notEmptyOptions)
  documents: UploadDocumentBatchElement[];

  attributes?: FormAttributesRequest;
}
